export default __webpack_public_path__ + "static/media/psactions_original.ea40b11d.jpg";